import React from "react";

export default function ContentHeaderBtnsBlock({children}) {
    return <div className="filter-buttons" id="contentHeaderBtnsBlock">
            {children}
        </div>

};